import {SVGProps} from 'react';

export const EmptyStateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? '64px'}
    height={props.height ?? '64px'}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_35942_38783)">
      <rect
        width="64"
        height="64"
        rx="32"
        fill="#D5F1FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.1776 43.0535C75.3693 40.0319 62.1153 10.3441 45.3751 10.3905C37.7557 10.411 33.0356 17.3752 31.5331 18.7493C31.1627 19.0876 30.867 19.2671 30.6223 19.3368C30.3724 19.3658 30.0279 19.3077 29.5578 19.1324C27.6473 18.4176 20.6685 13.7226 13.5945 16.5548C-1.94859 22.773 -3.13959 55.2626 -2.76276 58.3652C-2.17523 63.1839 -1.51803 67.7033 2.83286 71.9365C2.83286 71.9365 7.71702 76.4993 13.4206 75.665C19.1215 74.8313 23.012 70.1904 24.9915 65.0181C25.1847 64.5253 25.8207 64.3964 26.1906 64.7716L29.4596 67.9516C32.6191 71.0251 36.8317 72.054 40.7019 71.3033C44.5695 70.5532 48.0919 68.024 49.8759 63.9916L51.719 59.82C51.9213 59.3311 52.5598 59.2155 52.9233 59.6003C56.693 63.6575 62.0358 66.5046 67.6356 65.1492C73.2348 63.7911 76.0616 57.7327 76.0616 57.7327C78.5143 52.1799 77.4342 47.7425 76.1776 43.0535Z"
        fill="#00A6FB"
      />
      <path
        d="M20.7041 34.5173C20.8103 36.057 21.8509 39.1363 25.1638 39.1363C28.4767 39.1363 29.6234 36.057 29.7827 34.5173"
        stroke="#051923"
        strokeWidth="1.93062"
        strokeLinecap="round"
      />
      <path
        d="M34.7197 34.5173C34.8259 36.057 35.8665 39.1363 39.1794 39.1363C42.4923 39.1363 43.6391 36.057 43.7983 34.5173"
        stroke="#051923"
        strokeWidth="1.93062"
        strokeLinecap="round"
      />
      <path
        d="M11.1309 33.3908C12.7236 39.6025 21.8659 49.1589 32.9514 49.1589C44.0368 49.1589 50.2061 39.6025 53.4977 33.3908"
        stroke="#051923"
        strokeWidth="1.93062"
        strokeLinecap="round"
      />
    </g>
    <rect
      x="0.723982"
      y="0.723982"
      width="62.552"
      height="62.552"
      rx="31.276"
      stroke="url(#paint0_linear_35942_38783)"
      strokeWidth="1.44796"
    />
    <defs>
      <linearGradient
        id="paint0_linear_35942_38783"
        x1="9.6547e-07"
        y1="12.6707"
        x2="21.8642"
        y2="64.3373"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop
          offset="0.47"
          stopColor="#69CDFF"
        />
        <stop
          offset="1"
          stopColor="#051923"
        />
      </linearGradient>
      <clipPath id="clip0_35942_38783">
        <rect
          width="64"
          height="64"
          rx="32"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
